import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Detail", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("button", { type: "submit" }, "Update", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("form", {
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.handleUpdate()), ["prevent"]))
    }, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentTask.title) = $event)),
        type: "text",
        placeholder: "write a title"
      }, null, 512), [
        [_vModelText, _ctx.currentTask.title]
      ]),
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentTask.description) = $event)),
        rows: "3",
        placeholder: "write a description"
      }, null, 512), [
        [_vModelText, _ctx.currentTask.description]
      ]),
      _hoisted_2,
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleDelete()))
      }, "Delete")
    ], 32)
  ], 64))
}